module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABK0lEQVR4AWOgC3jFYr5XwySxQF90tbbQWnwIoeEVk/lLBourAuZVUYYq83UIaWAwf81v9tHF8L2J8Qd7o6es5rMdjB069XBqeCtr+jVP73OEwZdE/S9J+l8S9F9zmb1iNt8DdGc+wp0IDZ+j9T+6GX6wM/rRpf1a2Ox7g84HKyOgC4FOBaJrImZV0SB3IjR8K9N9r2sC1PC9RvcVmznQns8hBhANcPSQ2zq2OB+q4UuK3td0vc+hBt+bdN6qmPzs0/5gi7DhvGRgXtpGp447jp13oRpeC5l9r9f5FGTwNV/vW4nu1wy9l4wg1avMyyLKjwPVwREslBhBwfre3BjomTcSpk+ZrVuDZ3k0X4OpQyCkeGAGxcN50aC8VKjtCISpAWJ7OJLtODUMSgAAZmjHPEuWwUcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/ER.png
// module id = 1132
// module chunks = 0